import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logoWhite from '@/assets/images/logo_white.svg';
import { MyLink } from '@/components/MyLink';
import { APP_LINKS } from '@/helpers/links';
import { CONTACT_EMAIL } from '@/helpers/constants';
import { WhatsAppChatLink } from '../WhatsAppChatLink';
import { SocialButtonsGrey } from '../SocialButtonsGrey';
import { AppVersion } from '@/components/AppVersion';
import { useGetMe } from '@/hooks/shared/useGetMe';
import './index.scss';

export const Footer = () => {
  const location = useLocation();
  const date = new Date();
  const { t } = useTranslation('components');
  const currentYear = date.getFullYear();
  const { isLender, isCombinedMode, isLoading } = useGetMe();
  const isSplitLender = !isCombinedMode && isLender;

  return (
    <footer className="footer">
      <div
        className={
          (location && location.pathname === '/sign-in') ||
          location.pathname === '/sign-up' ||
          location.pathname === '/sign-up/fds' ||
          location.pathname === '/forgot-password'
            ? 'container'
            : 'container-inner'
        }
      >
        <div className="footer__inner">
          <nav>
            {(location && location.pathname === '/sign-in') ||
            location.pathname === '/sign-up/' ||
            location.pathname === '/sign-up/fds' ||
            location.pathname === '/forgot-password' ? (
              <ul>
                <li className="footer_logo">
                  <MyLink className="footer__logo" href={APP_LINKS.dashboard}>
                    <img src={logoWhite} alt="logo_white" />
                  </MyLink>
                </li>
              </ul>
            ) : null}
            <ul>
              <h4 className="f-20 f-500">{t('footer.company')}</h4>
              <li>
                <MyLink href={APP_LINKS.founderPromoDomain} isExternal>
                  {t('footer.home')}
                </MyLink>
              </li>
            </ul>
            <ul>
              <h4 className="f-20 f-500">{t('footer.legal')}</h4>
              <li>
                <MyLink href={APP_LINKS.docPrivacyAndPolicy} isExternal>
                  {t('footer.privacy_policy')}
                </MyLink>
              </li>
              <li>
                <MyLink href={APP_LINKS.docTermsOfUse} isExternal>
                  {t('footer.terms_of_use')}
                </MyLink>
              </li>
              <li>
                <MyLink href={APP_LINKS.docAssignmentAgreement} isExternal>
                  {t('footer.assignment_agreement')}
                </MyLink>
              </li>
              <li>
                <MyLink href={APP_LINKS.suretyAgreement} isExternal>
                  {t('footer.surety_agreement')}
                </MyLink>
              </li>
            </ul>
            {!isLoading && !isSplitLender && (
              <ul>
                <h4 className="f-20 f-500">{t('footer.help')}</h4>
                {/*<li>*/}
                {/*  <a href="/help">{t('footer.faq')}</a>*/}
                {/*</li>*/}
                <li>
                  <MyLink href={APP_LINKS.loanTermsPlans()}>{t('footer.loan_terms')}</MyLink>
                </li>
                <li>
                  <MyLink href={APP_LINKS.loanTermsRefinancing()} newWindow>
                    {t('footer.refinancing')}
                  </MyLink>
                </li>
                <li>
                  <MyLink href={APP_LINKS.loanTermsFpg()} newWindow>
                    {t('footer.fpg')}
                  </MyLink>
                </li>
                <li>
                  <MyLink href={APP_LINKS.loanTermsFlexibility()} newWindow>
                    {t('footer.flexibility')}
                  </MyLink>
                </li>
                <li>
                  <MyLink href={APP_LINKS.loanTermsReportingModes()} newWindow>
                    {t('footer.reporting_modes')}
                  </MyLink>
                </li>
              </ul>
            )}
            <ul>
              <h4 className="f-20 f-500">{t('footer.support')}</h4>
              <p>{t('footer.contact_us')}</p>
              <li>
                <WhatsAppChatLink />
              </li>
              <li>
                <MyLink href={`mailto:${CONTACT_EMAIL}`} isExternal>
                  {CONTACT_EMAIL}
                </MyLink>
              </li>
              <li>
                <SocialButtonsGrey className="footer__content-social" />
              </li>
            </ul>
          </nav>

          <hr />

          <div className="footer__content-copyright">
            <p>{t('footer.all_rights_reserved', { year: currentYear })}</p>
            <p>{t('footer.scramble_ou_registry')}</p>
          </div>
          <AppVersion color="#191919" />
        </div>
      </div>
    </footer>
  );
};
